export default __webpack_public_path__ + "static/media/giraffe-purple.4b16e305.svg";